import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { events } from "@/mocks/events";

export default function CategoryQuickEntry() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {categories.map((c) => {
        const count = events.filter((e) => e.categoryId === c.id).length;
        return (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group flex flex-col items-center gap-2.5 rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-colors hover:border-primary-300 hover:bg-primary-50/50"
          >
            <span
              className={`flex h-14 w-14 items-center justify-center rounded-xl text-2xl transition-transform group-hover:scale-105 ${c.accent}`}
            >
              <i className={c.icon}></i>
            </span>
            <span className="text-sm font-bold text-foreground-900">{c.name}</span>
            <span className="text-xs text-foreground-500">{count} 场收录</span>
          </Link>
        );
      })}
    </div>
  );
}